(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["onegovReactComponents"] = factory(require("react"), require("react-dom"));
	else
		root["onegovReactComponents"] = factory(root["React"], root["ReactDOM"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__59787__, __WEBPACK_EXTERNAL_MODULE__55156__) => {
return 